import { render, staticRenderFns } from "./SpeakerMenu.vue?vue&type=template&id=d471ead6&scoped=true"
import script from "./SpeakerMenu.vue?vue&type=script&lang=js"
export * from "./SpeakerMenu.vue?vue&type=script&lang=js"
import style0 from "./SpeakerMenu.vue?vue&type=style&index=0&id=d471ead6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d471ead6",
  null
  
)

export default component.exports